import {
    BuildingInspectionInfo,
    RainWaterPipesStatus,
    ProtectionUnderRoofStatus,
    RoofStatus,
    StairStatus,
    DoorbellType
} from "shared/types/building-inspection";

export const calculateBuildingVisualInspectionDotValues = (buildingInspectionInfo: BuildingInspectionInfo) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if (buildingInspectionInfo.rainWaterPipesStatus === RainWaterPipesStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Regenwaterpijpen in goede staat");
    } else if (buildingInspectionInfo.rainWaterPipesStatus === RainWaterPipesStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Regenwaterpijpen zichtbare schade");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Regenwaterpijpen te inspecteren");
    }


    if ([ProtectionUnderRoofStatus.OK, ProtectionUnderRoofStatus.NOT_REQUIRED].includes(buildingInspectionInfo.protectionUnderRoofStatus)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Onderdak / bescherming waterinfiltratie onder dak in orde");
    } else if (buildingInspectionInfo.protectionUnderRoofStatus === ProtectionUnderRoofStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Geen waterafdichting onder dak");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Onderdak of waterdichting onder dak te inspecteren");
    }

    if (buildingInspectionInfo.roofStatus === RoofStatus.OK) {
        dotValues.green.count++;
        dotValues.green.labels.push("Dak en dakbedekking in goede staat?");
    } else if (buildingInspectionInfo.roofStatus === RoofStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Dak of dakbedekking vertonen schade");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Dak en dakbeddeking te inspecteren");
    }

    if ([StairStatus.OK, StairStatus.NOT_REQUIRED].includes(buildingInspectionInfo.stairStatus)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Veilige trappen, inclusief trapspijlen en leuningen");
    } else if (buildingInspectionInfo.stairStatus === StairStatus.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Onveilige trappen of er ontbreken trapspijlen of leuningen");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Trappen te inspecteren");
    }

    if ([DoorbellType.CLASSIC, DoorbellType.VIDEO].includes(buildingInspectionInfo.doorbellType)) {
        dotValues.green.count++;
        dotValues.green.labels.push("Klassieke deurbel of videofoon");
    } else if (buildingInspectionInfo.doorbellType === DoorbellType.NOT_OK) {
        dotValues.red.count++;
        dotValues.red.labels.push("Geen werkende deurbel aanwezig");
    } else {
        dotValues.transparent.count++;
        dotValues.transparent.labels.push("Deurbel te inspecteren");
    }

    return dotValues;
};
